import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';

import { persistReducer } from 'redux-persist';

/**
 * Modules Reducers.
 */
import debtors from 'src/modules/debtors/reducers/debtors.reducer';
import product from 'src/modules/product/reducers/product.reducer';
import authentication from 'src/modules/auth/reducers/authentication.reducer';
import importer from 'src/modules/importer/reducers/importer.reducer';
import company from 'src/modules/company/reducers/company.reducer';
import bankAccount from 'src/modules/bank-account/reducers/bank-account.reducer';
import campaign from 'src/modules/campaign/reducers/campaign.reducer';
import deal from 'src/modules/deals/reducers/deal.reducer';
import dashboard from 'src/modules/dashboard/reducers/dashboard.reducer';
import debtorArea from 'src/modules/debtor-area/reducers/debtor-area.reducer';
import debt from 'src/modules/debts/reducers/debt.reducer';
import operator from 'src/modules/operators/reducers/operator.reducer';
import survey from 'src/modules/surveys/reducers/survey.reducer';
import requests from 'src/modules/requests/reducers/request.reducer';

import storage from 'redux-persist/lib/storage';

export default (history) => {
    const authPersistConfig = {
        key: 'authentication',
        storage,
        whitelist: ['authUser', 'authToken'],
    };

    const importerPersistConfig = {
        key: 'importer',
        storage,
        blackList: [],
    };

    const debtorsPersistConfig = {
        key: 'debtors',
        storage,
        whiteList: ['debtorInformation'],
    };

    const debtorAreaPersistConfig = {
        key: 'debtorArea',
        storage,
    };

    const operatorPersistConfig = {
        key: 'operator',
        storage,
        whitelist: ['dialerCall'],
    };

    const companyPersistConfig = {
        key: 'company',
        storage,
        whitelist: ['company'],
    };

    return combineReducers({
        router: connectRouter(history),
        authentication: persistReducer(authPersistConfig, authentication),
        debtors: persistReducer(debtorsPersistConfig, debtors),
        importer: persistReducer(importerPersistConfig, importer),
        company: persistReducer(companyPersistConfig, company),
        debtorArea: persistReducer(debtorAreaPersistConfig, debtorArea),
        operator: persistReducer(operatorPersistConfig, operator),
        product,
        form,
        bankAccount,
        campaign,
        deal,
        dashboard,
        debt,
        requests,
        survey,
    });
}
